import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

// project load more start
function chunkArray(array, size) {
    const chunkyArr = [];
    let index = 0;
    while (index < array.length) {
        chunkyArr.push(array.slice(index, size + index));
        index += size;
    }    
    return chunkyArr;
}
const projectCard = document.querySelectorAll(".project-card")
const itemsContainer = document.querySelector(".project__row");
const button = document.querySelector(".theme-button--load-more");
const postsShown = 9;
let count = 0;

if(button) {
    fetch(`/wp-json/project/all-posts`)
    .then((response) => response.json())
    .then((data) => {        
        data.splice(0, postsShown);
        const newData = chunkArray(data, postsShown);
        const currentChunk = newData[count];
    
        if (count == newData.length) {
            button.classList.add('d-none');
        }
    })
    button.addEventListener("click", () => {
        button.classList.add('loading');
    
        fetch(`/wp-json/project/all-posts`)
        .then((response) => response.json())
        .then((data) => {        
            data.splice(0, postsShown);
            const newData = chunkArray(data, postsShown);
            const currentChunk = newData[count];
    
            if (count <= newData.length) {
                const items = [];
                currentChunk.forEach((key, index) => {
                    const permalink = currentChunk[index].permalink;
                    const image = currentChunk[index].image;
                    const location = currentChunk[index].location;
                    const capacity = currentChunk[index].capacity;
                    const title = currentChunk[index].title;
                    const article = `
                        <div class="col-12 col-lg-4">
                            <a href="${permalink}" class="project-card">
                                <div class="project-card__image-container">
                                    <?php if(${image}) : ?>
                                    <img src="${image}" class="ratio-item project-card__image" alt="${title}">
                                    <?php endif; ?>
                                </div>
                                <p class="project-card__location-capacity">${location} - ${capacity}</p>
                                <h3 class="project-card__title">${title}</h3>
                            </a>
                        </div>`
                    items.push(article);
                });
    
                itemsContainer.insertAdjacentHTML("beforeend", items.join(""));
                count++;
    
                // set button to disable
                if (count === newData.length) {
                    button.classList.add('d-none');
                }
            }
            button.classList.remove('loading');
        })
        .catch((err) => {
            console.log("Something went wrong!", err);
        });
    });
}
// project load more finish

function detailProjectGallery() {
    var swiper = new Swiper(".detail-project__thumbnail-swiper", {
        slidesPerView: 3,
        spaceBetween: 14,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        }
    });
    var swiper2 = new Swiper(".detail-project__preview-swiper", {
        modules: [ Navigation, Thumbs ],
        spaceBetween: 30,
        allowTouchMove: false,
        navigation: {
            nextEl: ".detail-project__next",
            prevEl: ".detail-project__prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });
}

function otherProjectSection() {
    const otherProjectSwiper = new Swiper(".other-project__swiper", {
        modules: [ Pagination ],
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 450,
        // allowTouchMove: false,
        pagination: {
            el: ".other-project__pagination",
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        }
    });
}
function otherProjectSectionResponsive() {
    const header = document.querySelector('.other-project__header');
    const buttonWrapperMobile = document.querySelector('.other-project__button-wrapper-mobile');
    const button = document.querySelector('.other-project__button');

    if(buttonWrapperMobile) {
        if (window.innerWidth < 576) {
            buttonWrapperMobile.append(button);
        } else {
            header.append(button);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    detailProjectGallery();
    otherProjectSection();
    otherProjectSectionResponsive();
})

window.addEventListener('resize', () => {
    otherProjectSectionResponsive();
})